import session from '@/shared/session'

// initial state
const initialState = () => ({
	current: null,
	patient: {
		episodes: [],
		active_episodes: []
	}
})

const state = initialState()

// getters
const getters = {
	getCurrentEpisode: (state) => () => {
		return state.current
	},
	getEpisodes: (state) => () => {
		return state.patient.episodes
	},
	getActiveEpisodes: (state) => () => {
		return state.patient.active_episodes
	}
}

// actions
const actions = {
	resetState ({ commit }) {
		commit('reset_state')
	},

	async getEpisodeForCurrentDecursus({ commit, state, rootState }) {
		if (!rootState.decursus.current) {
			return
		}

		const current  = await session
			.get(`/api/episodes/${rootState.decursus.current?.episode}/`)

		commit("set_current", current.data)

		return state.current
	},

	async getEpisodeById({ commit, state }, id) {
		// const [current, episodes, active_episodes] = await Promise.all([
		// 	session.get(`/api/episodes/${id}/`),
		// 	session.get(`/api/patients/${rootState.patients.current?.id}/episodes/`),
		// 	session.get(`/api/patients/${rootState.patients.current?.id}/active_episodes/`),
		// ])

		const current = await session
			.get(`/api/episodes/${id}/`)

		commit("set_current", current.data)
		// commit("set_episodes", episodes.data)
		// commit("set_active_episodes", active_episodes.data)

		return state.current
	},

	async getEpisodesForCurrentPatient({ commit, state, rootState, dispatch }) {
		if (!rootState.patients.current) {
			return
		}

		dispatch("loading/load", "episodes", { root: true })
		
		const [all_episodes, active_episodes] = await Promise.all([
			session.get(`/api/patients/${rootState.patients.current?.id}/episodes/`),
			session.get(`/api/patients/${rootState.patients.current?.id}/active_episodes/`),
		])

		commit("set_episodes", all_episodes.data)
		commit("set_active_episodes", active_episodes.data)

		dispatch("loading/end", "episodes", { root: true })

		return state.patient
	},

	updateEpisode({ commit, dispatch, state }, data) {
		dispatch("loading/load", "episodes", { root: true })
		return session
				.put(`/api/episodes/${state.current?.id}/`, data)
				.then(episode => {
					commit("set_current", episode.data)
				})
				.then(() => {
					return dispatch("getEpisodesForCurrentPatient")
				})
	      .finally(() => {
	        dispatch("loading/end", "episodes", { root: true })
	      })
	},

	createNewEpisode({ commit, dispatch, rootState }, data) {
		dispatch("loading/load", "episodes", { root: true })
		return session
			.post(`/api/episodes/`, {...data,  patient: rootState.patients.current?.id})
			.then(() => {
				return dispatch("getEpisodesForCurrentPatient")
			})
      .finally(() => {
        dispatch("loading/end", "episodes", { root: true })
      })
	},

	mergeEpisodes({ commit, dispatch }, data) {
		dispatch("loading/load", "episodes", { root: true })
		return session
			.post(`/api/episodes/merge/`, data)
			.then(() => {
				return dispatch("getEpisodesForCurrentPatient")
			})
      .finally(() => {
        dispatch("loading/end", "episodes", { root: true })
      })
	},

	activateEpisode({ commit, dispatch }, id) {
		dispatch("loading/load", "episodes", { root: true })
		return session
			.patch(`/api/episodes/${id}/activate/`)
			.then(() => {
				return dispatch("getEpisodesForCurrentPatient")
			})
      .finally(() => {
        dispatch("loading/end", "episodes", { root: true })
      })
	},

	bookmarkEpisode({ commit, dispatch }, { id, bookmarked }) {
		dispatch("loading/load", "episodes", { root: true })
		return session
			.patch(`/api/episodes/${id}/bookmark/`, {bookmarked: bookmarked })
			.then(() => {
				return dispatch("getEpisodesForCurrentPatient")
			})
	      .finally(() => {
	        dispatch("loading/end", "episodes", { root: true })
	      })
	},

	sortEpisodes({ commit, dispatch }, data) {
		return session
			.patch(`/api/episodes/sort/`, data)
			.then(() => {
				return dispatch("getEpisodesForCurrentPatient")
			})
	},

	async getEpisodeOverview({ commit }, id) {
		const overview  = await session
			.get(`/api/episodes/${id}/overview/`)
		return overview.data
	}
}

// mutations
const mutations = {
  reset_state(state) {
		Object.assign(state, initialState())
  },

	set_current(state, current) {
		state.current = current
	},
	set_episodes(state, episodes) {
		state.patient.episodes = episodes
	},
	set_active_episodes(state, episodes) {
		state.patient.active_episodes = episodes
	},
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}